/**
 * Empório Saibai — zonas de entrega (SP capital + Sorocaba).
 * Valida CEP via ViaCEP (bairro) e trava checkout fora da área.
 * Veltrus · Shopify Partner 4969609
 */
(function () {
  'use strict';

  if (window.SaibaiDelivery) return;

  var STORAGE_KEY = 'saibai_delivery_zone_v1';
  var MSG_OUT =
    'No momento entregamos apenas em bairros selecionados de São Paulo (capital) e Sorocaba. ' +
    'Seu CEP está fora da área de cobertura.';
  var MSG_OK_PREFIX = 'Entregamos em ';
  var WHATSAPP =
    (window.saibaiDeliveryZones && window.saibaiDeliveryZones.whatsapp) ||
    'https://wa.me/551530101451';

  var SP_BAIRROS = [
    'Itaim Bibi',
    'Moema',
    'Vila Mariana',
    'Pinheiros',
    'Perdizes',
    'Jardim Paulista',
    'Butanta',
    'Butantã',
    'Vila Sonia',
    'Vila Sônia',
    'Rio Pequeno',
    'Lapa',
    'Consolacao',
    'Consolação',
    'Santa Cecilia',
    'Santa Cecília',
    'Se',
    'Sé',
    'Republica',
    'República',
    'Bela Vista',
    'Liberdade',
    'Bras',
    'Brás',
    'Pari',
    'Bom Retiro',
    'Mooca',
    'Agua Rasa',
    'Água Rasa'
  ];

  var SOROCABA_BAIRROS = [
    'Centro',
    'Eden',
    'Éden',
    'Cajuru',
    'Parque Sao Bento',
    'Parque São Bento',
    'Campolim',
    'Parque Campolim',
    'Jardim America',
    'Jardim América',
    'Vila Jardini',
    'Wanel Ville',
    'Jardim Simus',
    'Alem Ponte',
    'Além Ponte',
    'Vila Haro',
    'Aparecidinha',
    'Industrial'
  ];

  /*
   * CEPs 1:1 com planilha frete (34 linhas) — sem setores amplos.
   * docs/FLEX-FRETE-CEP-ZONAS-SAIBAI-2026-07-29.md · exports/flex-frete-cep-ranges-saibai.csv
   * Prefixos 5 dígitos → faixa 8 (ex.: 04530 → 04530000–04539999).
   */
  var CEP_RANGES = [
    /* SP Segunda */
    [4530000, 4539999], /* Itaim Bibi 04530–04539 */
    [4077000, 4094999], /* Moema 04077–04094 */
    [4010000, 4120999], /* Vila Mariana 04010–04120 */
    [5400000, 5449999], /* Pinheiros 05400–05449 */
    [5010000, 5019999], /* Perdizes 05010–05019 */
    [1400000, 1499999], /* Jardim Paulista 01400–01499 */
    /* SP Quarta */
    [5503000, 5519999], /* Butantã 05503–05519 */
    [5626000, 5629999], /* Vila Sônia 05626–05629 */
    [5379000, 5379999], /* Rio Pequeno 05379 */
    [5070000, 5099999], /* Lapa 05070–05099 */
    [1300000, 1309999], /* Consolação 01300–01309 */
    [1200000, 1249999], /* Santa Cecília 01200–01249 */
    /* SP Sexta */
    [1000000, 1049999], /* Sé 01000–01049 */
    [1050000, 1249999], /* República 01050–01249 */
    [1310000, 1329999], /* Bela Vista 01310–01329 */
    [1500000, 1599999], /* Liberdade 01500–01599 */
    [3000000, 3049999], /* Brás 03000–03049 */
    [3020000, 3039999], /* Pari 03020–03039 */
    [1120000, 1129999], /* Bom Retiro 01120–01129 */
    [3100000, 3189999], /* Mooca 03100–03189 */
    [3345000, 3349999], /* Água Rasa 03345–03349 */
    /* Sorocaba */
    [18000000, 18019999], /* Centro 18000–18019 */
    [18103000, 18109999], /* Éden 18103–18109 */
    [18105000, 18109999], /* Cajuru 18105–18109 */
    [18072000, 18073999], /* Parque São Bento 18072–18073 */
    [18047000, 18048999], /* Campolim 18047–18048 */
    [18046000, 18046999], /* Jardim América 18046 */
    [18044000, 18044999], /* Vila Jardini 18044 */
    [18055000, 18057999], /* Wanel Ville 18055–18057 */
    [18055000, 18055999], /* Jardim Simus 18055 */
    [18013000, 18013999], /* Além Ponte 18013 */
    [18015000, 18015999], /* Vila Haro 18015 */
    [18087000, 18087999], /* Aparecidinha 18087 */
    [18087000, 18088999] /* Industrial 18087–18088 */
  ];

  function onlyDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function formatCep(value) {
    var d = onlyDigits(value).slice(0, 8);
    if (d.length <= 5) return d;
    return d.slice(0, 5) + '-' + d.slice(5);
  }

  function normalize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function bairroMatches(bairroRaw, allowedRaw) {
    var bairro = normalize(bairroRaw);
    var allowed = normalize(allowedRaw);
    if (!bairro || !allowed) return false;
    if (bairro === allowed) return true;
    if (allowed.length <= 4) return false;
    return bairro.indexOf(allowed) !== -1 || allowed.indexOf(bairro) !== -1;
  }

  function listHasBairro(list, bairro) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (bairroMatches(bairro, list[i])) return true;
    }
    return false;
  }

  function cepInRanges(digits) {
    var n = parseInt(onlyDigits(digits), 10);
    if (isNaN(n)) return false;
    var i;
    for (i = 0; i < CEP_RANGES.length; i++) {
      if (n >= CEP_RANGES[i][0] && n <= CEP_RANGES[i][1]) return true;
    }
    return false;
  }

  function isEligibleAddress(address) {
    if (!address || address.erro) return false;
    var uf = String(address.uf || '').toUpperCase();
    if (uf !== 'SP') return false;

    var city = normalize(address.localidade);
    var bairro = address.bairro || '';
    var digits = onlyDigits(address.cep);

    if (city === 'sao paulo') {
      if (bairro && listHasBairro(SP_BAIRROS, bairro)) return true;
      if (!bairro && cepInRanges(digits)) return true;
      return false;
    }
    if (city === 'sorocaba') {
      if (bairro && listHasBairro(SOROCABA_BAIRROS, bairro)) return true;
      if (!bairro && cepInRanges(digits)) return true;
      return false;
    }
    return false;
  }

  function fetchCep(cep) {
    var digits = onlyDigits(cep);
    if (digits.length !== 8) {
      return Promise.reject(new Error('cep_invalid'));
    }
    return fetch('https://viacep.com.br/ws/' + digits + '/json/')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!data || data.erro) throw new Error('cep_not_found');
        return data;
      });
  }

  function readState() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function writeState(state) {
    try {
      if (!state) {
        window.sessionStorage.removeItem(STORAGE_KEY);
        return;
      }
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      /* ignore */
    }
  }

  function syncCartAttributes(state) {
    var attrs = {
      delivery_cep: state && state.ok ? state.cep : '',
      delivery_bairro: state && state.ok ? state.bairro : '',
      delivery_city: state && state.ok ? state.city : '',
      delivery_zone_ok: state && state.ok ? '1' : '0'
    };
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {
      return null;
    });
  }

  function rememberFromAddress(address, ok) {
    var digits = onlyDigits(address && address.cep);
    var state = {
      ok: !!ok,
      cep: formatCep(digits),
      bairro: (address && address.bairro) || '',
      city: (address && address.localidade) || '',
      uf: (address && address.uf) || '',
      checkedAt: Date.now()
    };
    writeState(state);
    syncCartAttributes(state);
    return state;
  }

  function validateCep(cep) {
    var digits = onlyDigits(cep);
    return fetchCep(digits).then(function (address) {
      var ok = isEligibleAddress(address);
      var state = rememberFromAddress(address, ok);
      return {
        ok: ok,
        address: address,
        state: state,
        message: ok
          ? MSG_OK_PREFIX +
            (address.bairro ? address.bairro + ', ' : '') +
            address.localidade +
            '.'
          : MSG_OUT
      };
    });
  }

  function isCheckoutAllowed() {
    var state = readState();
    return !!(state && state.ok === true);
  }

  function setCheckoutDisabled(disabled, reason) {
    var buttons = document.querySelectorAll(
      'button[name="checkout"], .cart__checkout-button, a[href*="/checkout"]'
    );
    var i;
    for (i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.tagName === 'A') {
        if (disabled) {
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('saibai-delivery-locked-link');
          btn.addEventListener('click', blockAnchorCheckout, true);
        } else {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('saibai-delivery-locked-link');
          btn.removeEventListener('click', blockAnchorCheckout, true);
        }
      } else if (disabled) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('data-saibai-delivery-locked', '1');
        if (reason) btn.setAttribute('title', reason);
      } else if (btn.getAttribute('data-saibai-delivery-locked') === '1') {
        btn.removeAttribute('data-saibai-delivery-locked');
        btn.removeAttribute('title');
        var wrapper = btn.closest('[data-purchase-conditions]');
        var checkbox = wrapper ? wrapper.querySelector('[id^="agree_condition-"]') : null;
        if (checkbox) {
          btn.disabled = !checkbox.checked;
        } else {
          btn.removeAttribute('disabled');
        }
      }
    }

    document.documentElement.classList.toggle('saibai-delivery-locked', disabled);
    document.documentElement.classList.toggle('saibai-delivery-ok', !disabled);

    var dyn = document.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons');
    for (i = 0; i < dyn.length; i++) {
      dyn[i].hidden = !!disabled;
      dyn[i].style.display = disabled ? 'none' : '';
    }
  }

  function blockAnchorCheckout(e) {
    if (!isCheckoutAllowed()) {
      e.preventDefault();
      e.stopPropagation();
      focusGate();
    }
  }

  function focusGate() {
    var input = document.querySelector('[data-saibai-delivery-cep]');
    if (input) {
      input.focus();
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function gateHtml() {
    return (
      '<div class="saibai-delivery-gate" data-saibai-delivery-gate>' +
      '<p class="saibai-delivery-gate__label">CEP de entrega</p>' +
      '<p class="saibai-delivery-gate__hint">Entregamos em bairros selecionados de São Paulo capital e Sorocaba.</p>' +
      '<form class="saibai-delivery-gate__form" data-saibai-delivery-form novalidate>' +
      '<label class="visually-hidden" for="SaibaiDeliveryCep">CEP</label>' +
      '<input id="SaibaiDeliveryCep" class="saibai-delivery-gate__input" type="text" inputmode="numeric" autocomplete="postal-code" placeholder="00000-000" maxlength="9" required data-saibai-delivery-cep>' +
      '<button type="submit" class="saibai-delivery-gate__btn" data-saibai-delivery-submit>Verificar</button>' +
      '</form>' +
      '<p class="saibai-delivery-gate__msg" data-saibai-delivery-msg hidden role="status" aria-live="polite"></p>' +
      '<p class="saibai-delivery-gate__out" data-saibai-delivery-out hidden>' +
      '<a href="' +
      WHATSAPP +
      '" target="_blank" rel="noopener noreferrer">Falar no WhatsApp sobre outras regiões</a>' +
      ' · <a href="/pages/politica-de-entrega">Ver áreas atendidas</a>' +
      '</p>' +
      '</div>'
    );
  }

  function showMsg(gate, text, kind) {
    var msg = gate.querySelector('[data-saibai-delivery-msg]');
    var out = gate.querySelector('[data-saibai-delivery-out]');
    if (!msg) return;
    msg.hidden = !text;
    msg.textContent = text || '';
    msg.className =
      'saibai-delivery-gate__msg' +
      (kind === 'ok' ? ' is-ok' : '') +
      (kind === 'err' ? ' is-err' : '');
    if (out) out.hidden = kind !== 'err';
  }

  function bindGate(gate) {
    if (!gate || gate.dataset.bound === 'true') return;
    gate.dataset.bound = 'true';

    var form = gate.querySelector('[data-saibai-delivery-form]');
    var input = gate.querySelector('[data-saibai-delivery-cep]');
    var btn = gate.querySelector('[data-saibai-delivery-submit]');
    if (!form || !input) return;

    var existing = readState();
    if (existing && existing.cep) {
      input.value = existing.cep;
      if (existing.ok) {
        showMsg(
          gate,
          MSG_OK_PREFIX +
            (existing.bairro ? existing.bairro + ', ' : '') +
            existing.city +
            '.',
          'ok'
        );
        setCheckoutDisabled(false);
      } else {
        showMsg(gate, MSG_OUT, 'err');
        setCheckoutDisabled(true, MSG_OUT);
      }
    } else {
      setCheckoutDisabled(true, 'Informe um CEP de entrega atendido para continuar.');
    }

    input.addEventListener('input', function () {
      input.value = formatCep(input.value);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var cep = onlyDigits(input.value);
      if (cep.length !== 8) {
        showMsg(gate, 'Informe um CEP válido com 8 dígitos.', 'err');
        setCheckoutDisabled(true, MSG_OUT);
        return;
      }
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      validateCep(cep)
        .then(function (result) {
          showMsg(gate, result.message, result.ok ? 'ok' : 'err');
          setCheckoutDisabled(!result.ok, result.message);
        })
        .catch(function () {
          showMsg(gate, 'Não foi possível validar este CEP. Tente novamente.', 'err');
          setCheckoutDisabled(true, MSG_OUT);
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
        });
    });
  }

  function ensureGates() {
    var hosts = document.querySelectorAll('[data-purchase-conditions]');
    var i;
    for (i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      if (host.querySelector('[data-saibai-delivery-gate]')) continue;
      var ctas = host.querySelector('.cart__ctas');
      var wrap = document.createElement('div');
      wrap.innerHTML = gateHtml();
      var gate = wrap.firstChild;
      if (ctas) {
        host.insertBefore(gate, ctas);
      } else {
        host.insertBefore(gate, host.firstChild);
      }
      bindGate(gate);
    }

    var gates = document.querySelectorAll('[data-saibai-delivery-gate]');
    for (i = 0; i < gates.length; i++) {
      bindGate(gates[i]);
    }

    if (!isCheckoutAllowed()) {
      setCheckoutDisabled(true, 'Informe um CEP de entrega atendido para continuar.');
    } else {
      setCheckoutDisabled(false);
    }
  }

  function interceptCheckoutClicks() {
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target && e.target.closest
          ? e.target.closest('button[name="checkout"], .cart__checkout-button, a[href*="/checkout"]')
          : null;
        if (!t) return;
        if (isCheckoutAllowed()) return;
        e.preventDefault();
        e.stopPropagation();
        ensureGates();
        focusGate();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.querySelector) return;
        var checkoutBtn = form.querySelector('button[name="checkout"]');
        if (!checkoutBtn && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart') === -1) {
          return;
        }
        /* Cart forms posting to checkout */
        if (!isCheckoutAllowed() && (checkoutBtn || (e.submitter && e.submitter.name === 'checkout'))) {
          e.preventDefault();
          e.stopPropagation();
          ensureGates();
          focusGate();
        }
      },
      true
    );
  }

  function init() {
    ensureGates();
  }

  window.SaibaiDelivery = {
    formatCep: formatCep,
    onlyDigits: onlyDigits,
    normalize: normalize,
    isEligibleAddress: isEligibleAddress,
    validateCep: validateCep,
    fetchCep: fetchCep,
    rememberFromAddress: rememberFromAddress,
    isCheckoutAllowed: isCheckoutAllowed,
    getState: readState,
    messageOut: MSG_OUT,
    refresh: ensureGates
  };

  interceptCheckoutClicks();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', init);
  document.addEventListener('cart-drawer:open', init);

  /* Re-aplica após re-render do drawer/carrinho (debounced) */
  if (typeof MutationObserver === 'function') {
    var moTimer = null;
    var mo = new MutationObserver(function () {
      if (moTimer) window.clearTimeout(moTimer);
      moTimer = window.setTimeout(function () {
        if (
          document.querySelector('[data-purchase-conditions]') &&
          !document.querySelector('[data-saibai-delivery-gate]')
        ) {
          ensureGates();
        }
      }, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
